// src/lib/metrics/types.ts
/**
 * Centralized type definitions for metrics calculations
 */

/** A numeric series that may contain null/undefined values */
export type Series = (number | null | undefined)[];

/** A numeric series with only valid numbers (after filtering) */
export type ValidSeries = number[];

/** Time series with dates and values */
export interface TimeSeries {
  dates: (string | number)[];
  values: Series;
}

/** Rolling window configuration */
export interface RollingConfig {
  /** Window size in data points */
  window: number;
  /** Minimum points required for valid calculation */
  minPoints?: number;
}

/** Benchmark comparison result */
export interface BenchmarkMetrics {
  alpha: number | null;
  beta: number | null;
  correlation: number | null;
  upsideCapture: number | null;
  downsideCapture: number | null;
  captureSpread: number | null;
}

/** Risk metrics result */
export interface RiskMetrics {
  volatility: number | null;
  sharpe: number | null;
  sortino: number | null;
  maxDrawdown: number | null;
  currentDrawdown: number | null;
  var95: number | null;
  es95: number | null;
}

/** Distribution metrics result */
export interface DistributionMetrics {
  skewness: number | null;
  kurtosis: number | null;
  mean: number | null;
  median: number | null;
  stdDev: number | null;
}

/** Rolling metric function signature */
export type RollingMetricFn = (
  values: number[],
  window: number,
  minPoints?: number
) => number[];

/** Annualization constants */
export const TRADING_DAYS = {
  CRYPTO: 365,
  TRADITIONAL: 252,
} as const;

/** Default risk-free rate (annualized) */
export const DEFAULT_RISK_FREE_RATE = 0;

/** Confidence levels for VaR/ES */
export const CONFIDENCE_LEVELS = {
  VAR_95: 0.95,
  VAR_99: 0.99,
} as const;

